import { isConsentPurpose, isConsentStatus } from './contract'
import type { ConsentPurpose, ConsentState } from './contract'

export function parseConsentState(value: unknown): ConsentState | undefined {
  if (typeof value !== 'string' || value.length === 0) return undefined

  try {
    const parsed = JSON.parse(value) as Partial<ConsentState>
    if (parsed.version !== 1 || !isConsentStatus(parsed.status)) return undefined
    if (!Array.isArray(parsed.purposes) || typeof parsed.expiresAt !== 'number') return undefined
    if (parsed.expiresAt <= Date.now()) return undefined
    if (parsed.decidedAt != null && typeof parsed.decidedAt !== 'number') return undefined

    const purposes = parsed.purposes.filter(isConsentPurpose)
    if (purposes.length !== parsed.purposes.length) return undefined

    return {
      version: 1,
      status: parsed.status,
      purposes,
      decidedAt: parsed.decidedAt ?? 0,
      expiresAt: parsed.expiresAt,
    }
  } catch {
    return undefined
  }
}

export function hasConsentDecision(value: unknown): boolean {
  return parseConsentState(value) != null
}

export function hasGrantedPurpose(value: unknown, purpose?: ConsentPurpose): boolean {
  const state = parseConsentState(value)
  if (!state || state.status !== 'accepted') return false
  return purpose == null ? state.purposes.length > 0 : state.purposes.includes(purpose)
}
